import App from '../app';

require('publicPath');
const $ = require('jquery');
const Lazyload = require('lazyload');

const app = new App();
const entryData = window._sharedData.entry_data;

const $images = $('.product img').get();
const lazy = new Lazyload($images);
const $formSearch = $('.product-filter form');

require('select2');


function configurePriceSlider() {
  const $maxPrice = $('#max-price');
  $maxPrice
    .on('input', function (event) {
      const value = $maxPrice.val();
      let limitSelected = 'Sín limite';
      if (value > 0) {
        limitSelected = `${$maxPrice.val()}&euro;`;
      }
      $maxPrice.parents('.form-group').find('.value').html(limitSelected);
    })
    .trigger('input');
}

$formSearch.on('submit', function (event) {
  // Check if search is limited
  const $inputLimitSearch = $formSearch.find('#limit_search');
  if ($inputLimitSearch && $inputLimitSearch.prop('checked')) {
    $formSearch.attr('action', $inputLimitSearch.val());
  }
});

$('.selector select').select2({
  theme: 'bootstrap4',
  width: '99%',
});
if (entryData.pageType === 'category') {
  $('.selector select').on('change', function (event) {
    const terms = $('.selector select').select2('val');
    let actionURL = '';
    if (terms.length === 1 && terms[0] == entryData.category) {
      // Form action is category URL
      actionURL = entryData.categoryURL;
    } else {
      // Form action is search URL
      actionURL = entryData.searchURL;
    }

    $formSearch.attr('action', actionURL);
  });
}

configurePriceSlider();

$('.link-qty').on('click', function (event) {
  const qty = $(event.currentTarget).data('qty');
  $('#input-items').val(qty);
  $formSearch.submit();
});

$('#sort').on('change', function (event) {
  const sortBy = $('#sort').val();

  $('#input-sort').val(sortBy);
  $formSearch.submit();
});

// Detectar imagenes fallidas
$('.product-list img').on('error', function () {
  const $img = $(this);
  $img
    .parent('a')
    .html(
      '<div class="img-not-found" data-reason="failed">Imagen no disponible</div>'
    );
});
